import React from 'react';
import { useParams } from 'react-router-dom';
import { useTenancy } from '@/contexts/TenancyContext';

// Import original RiskRegister component
import RiskRegister from '../../risk-register';
// Import context provider without UI elements
import AuditorContextProvider from '../components/AuditorContextProvider';

/**
 * Auditor Risk Register - read-only version of the Risk Register
 * This component reuses the original Risk Register component with read-only mode
 * We use AuditorContextProvider to get the context providers but avoid duplicate headers
 */
const AuditorRiskRegister: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const { activeTenancy } = useTenancy();

  return (
    <AuditorContextProvider>
      <RiskRegister 
        basePath="/auditor-view/risk-detail" 
        isReadOnly={true} 
      />
    </AuditorContextProvider>
  );
};

export default AuditorRiskRegister;